import React from "react";
import { whoIsItForContent } from "../../utils/data";
import { useTranslation } from "react-i18next";

const ForWhom = () => {
  const { t } = useTranslation('home');
  return (
    <section className="flex flex-col gap-20 p-36 md-max:gap-10 lg-small:p-16 md-max:p-8">
      <div className="flex flex-col gap-4 pt-20">
        <p className="text-[#808897] px-2.5 py-1 border border-[#808897] rounded-md flex gap-1 w-max items-center">
          {t('forWhom.miniTitle')}
        </p>
        <h2 className="text-6xl md-small:text-4xl font-medium max-w-2xl">
          {t('forWhom.title')}
        </h2>
        <p className="text-[#666D80] text-lg md-small:text-base max-w-xl">
          {t('forWhom.description')}
        </p>
      </div>

      <div className="grid grid-cols-3 md-small:grid-cols-1 gap-x-6 gap-y-8">
        {t('forWhom.cards', { returnObjects: true }).map((item, index) => (
          <div
            key={index}
            className="p-7 flex flex-col items-center gap-4 relative rounded-2xl overflow-hidden"
          >
            <img src={item.icon} alt="icon" className="z-30 size-16" />
            <p className="text-[#333333] font-semibold text-xl text-center z-30">
              {item.title}
            </p>
            <p className="text-[#666666] text-center z-30">
              {item.description}
            </p>
            <img
              src={"/card-bg.png"}
              alt="Rail Rolls"
              className="absolute bottom-0 right-0 w-full h-full object-cover z-20"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default ForWhom;
